module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card"
  }, [(_vm.user) ? _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.remove($event)
      }
    }
  }, [_vm._v("\n\t\t\t\tdelete\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "card-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateModal
    }
  }, [_vm._v("\n\t\t\t\tedit\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "card-add-stack",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stackModal
    }
  }, [_vm._v("\n\t\t\t\tedit stacks\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "card-type"
  }, [_vm._v(_vm._s(_vm.card.type))]), _vm._v(" "), (_vm.card.type == 'stack') ? _c('div', {
    staticClass: "card-preview-stack"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.card.length) + " cards by " + _vm._s(_vm.card.username))])])]) : _c('div', [_c('h5', {
    staticClass: "card-source"
  }, [_vm._v(_vm._s(_vm.card.source))]), _vm._v(" "), _c('h3', {
    staticClass: "card-title"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.card.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-preview"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url,
      "target": "_blank"
    }
  }, [(_vm.card.show === 'image') ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.card.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.card.show === 'text') ? _c('blockquote', [_vm._v(_vm._s(_vm.card.snippet))]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.card.description) ? _c('p', {
    staticClass: "card-curator-note"
  }, [_c('strong', [_vm._v(_vm._s(_vm.card.username) + ":")]), _vm._v(" " + _vm._s(_vm.card.description))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "card-stacks",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks \n\t\t\t"), (_vm.card.stackCount > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.card.stackCount) + ")")]) : _c('span', [_vm._v("(0)")])]), _vm._v(" "), (_vm.stack) ? _c('span', {
    staticClass: "card-count"
  }, [_vm._v(_vm._s(_vm.index + 1) + " / " + _vm._s(_vm.stack.cardCount) + " cards")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4dfdc339"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/Card.vue
// module id = 198
// module chunks = 1